const BASE_PATH = '/inventory/job-orders';

export const NEW_JOB_ORDER_ENDPOINTS = {
  drafts: `${BASE_PATH}/drafts`,
  draft: `${BASE_PATH}/drafts/:id`
};
